import { PaperclipIcon } from 'lucide-react';
import { env } from '~/env';
import type { Task } from '~/modules/task/types';

/**
 * SummaryButtons component displays a concise overview of a task's details, such as the number of checklist items completed and total, as well as the count of media attachments. It also indicates if the task has expandable content. This component is designed to be shown on task cards in a compact form, providing quick insights without needing to open the task details.
 */
export function TaskCardSummaryButtons({ task }: { task: Task }) {
  const attachmentsCount = task.attachments?.length ?? 0;

  const checkedCount = task.checkedCount ?? 0;
  const totalCount = task.checkboxCount ?? 0;

  return (
    <>
      {
        <div className="mt-[-0.15rem] ml-1 inline-flex items-center gap-1">
          {task.expandable && <div className="inline-flex min-h-5 cursor-pointer py-0 text-muted-foreground text-sm">...</div>}
          {totalCount > 0 && (
            <div className="inline-flex min-h-5 cursor-pointer gap-[.15rem] text-sm">
              <span className="text-success">{checkedCount}</span>
              <span className="text-muted-foreground">/</span>
              <span className="">{totalCount}</span>
            </div>
          )}
          {attachmentsCount > 0 && (
            <div className="inline-flex cursor-pointer items-center text-sm">
              <PaperclipIcon className="size-2.5 -rotate-45 transition-transform" />
              <span className="">{attachmentsCount}</span>
            </div>
          )}
        </div>
      }
      {/*  in debug mode: show order number to debug drag */}
      {env.VITE_DEBUG_UI && <span className="ml-2 text-center text-muted-foreground text-sm">#{task.displayOrder}</span>}
    </>
  );
}
